<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
    	<el-breadcrumb-item>能耗分析</el-breadcrumb-item>
    	<el-breadcrumb-item>线损分析</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search"  @submit.native.prevent>
      <el-form-item v-if="user.username == 'admin'" label="选择部门">
          <el-select v-model="formInline.depId" placeholder="请选择部门"  size="small" @change="chageDept">
             <el-option
               v-for="item in deptList"
               :key="item.id"
               :label="item.departmentName"
               :value="item.id">
             </el-option>
           </el-select>
       </el-form-item>
      <el-form-item >
          <el-select v-model="formInline.areaId" placeholder="请选择区域"  size="small" clearable>
             <el-option
               v-for="item in areaList"
               :key="item.id"
               :label="item.areaName"
               :value="item.id">
             </el-option>
           </el-select>
       </el-form-item>


      <el-form-item>
      	<div style="position: relative;top: 1px;">
      	<el-date-picker
      	  size="small"
      	  v-model="dayStr"
          value-format="yyyy-MM-dd"
      	  type="daterange"
      	  range-separator="至"
      	  start-placeholder="开始日期"
      	  @change="getDate"
      	  end-placeholder="结束日期">
      	</el-date-picker>
      	</div>
      </el-form-item>


    	<el-form-item>
    		<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
    	</el-form-item>
    </el-form>

    <el-table  :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
     style="width: 100%;"  stripe :max-height="tableHeight" :row-class-name="tableRowClassName">
    	<el-table-column align="center" type="index" width="60">
    	</el-table-column>
    	<el-table-column prop="meterInfoName" label="计量点"   show-overflow-tooltip>
    	</el-table-column>
    	<el-table-column prop="terminalName" label="所属单元"  show-overflow-tooltip>
    	</el-table-column>
    	<el-table-column prop="areaName" label="所属区域"  show-overflow-tooltip>
    	</el-table-column>
      <el-table-column prop="totalValue" label="总用能"  show-overflow-tooltip>
    	</el-table-column>
      <el-table-column prop="sonTotalValue" label="子表总用能"  show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="difference" label="线损率"  show-overflow-tooltip>
        <template slot-scope="scope">
           {{scope.row.difference}}%
        </template>
      </el-table-column>
      <el-table-column label="操作" center width="180">
        <template slot-scope="scope">
           <el-button size="mini" @click="showChild(scope.row)">查看子表</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-if="showPage" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 查看子表 -->
    <el-dialog  title="查看子表"  :visible.sync="subFrom" width="70%" @click='subFrom = false' @close="childClose">
    	<!-- <el-input size="small" v-model="searchDatas" placeholder="请输入搜索内容" style="margin-bottom: 14px;"></el-input> -->

      <div class="stepBox">
        <div class="stepItem" v-for="(item,idx) in breadList" @click="getChildDataByIdx(item,idx)">
          {{item.meterInfoName}}
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    	<el-table size="small" :data="subList" border height="500px"  ref='bindTable'
    	 v-loading="loadMeter">
    		<el-table-column prop="meterInfoName" label="计量点"   show-overflow-tooltip>
    		</el-table-column>
    		<el-table-column prop="terminalName" label="所属单元"  show-overflow-tooltip>
    		</el-table-column>
    		<el-table-column prop="areaName" label="所属区域"  show-overflow-tooltip>
    		</el-table-column>
    		<el-table-column prop="totalValue" label="总用能"  show-overflow-tooltip width="120">
    		</el-table-column>
    		<el-table-column prop="sonTotalValue" label="子表总用能"  show-overflow-tooltip width="120">
    		</el-table-column>
    		<el-table-column prop="difference" label="差值"  show-overflow-tooltip width="120">
    		</el-table-column>
    		<el-table-column label="操作" center width="180">
    		  <template slot-scope="scope">
    		     <el-button size="mini" @click="showChild(scope.row)">查看子表</el-button>
    		  </template>
    		</el-table-column>

    	</el-table>
       <Pagination v-if="showPage" v-bind:child-msg="subPageParm" @callFather="callFatherSub"></Pagination>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='subFrom = false'>取消</el-button>
    		<!-- <el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveChild()">确认</el-button> -->
    	</div>
    </el-dialog>
  </div>
</template>

<script>
  import { findRoomAccountList  } from '../../api/payMG.js'
  import { getDepartmentTerminalInfoLis,getMainMeterInfoDataByCode ,findAreaList} from '../../api/energyMG'
  import {timestampToTime} from '@/utils/util'
  import Pagination from '../../components/Pagination'
  export default{
    data(){
      return {
        tableHeight:0,
        dataList:[],
        dayStr:[],
        payType:[
        	{lable:'充值',value:1},
          {lable:'退款',value:2},
        	{lable:'扣费',value:3},

        ],
        departmentId:"",
        breadList:[],
        subList:[],
        curId:"",
        loadMeter:false,
        subFrom:false,
        formInline:{
          terminalCode:"",
          startTime:"",
          endTime:"",
          depId:"",
          areaId:""
        },
        user:{},
        diff:0,
        showPage:true,
        loading:false,
        deptList:[],
        areaList:[],
        pageparm: {
        	currentPage: 1,
        	pageSize: 10,
        	total: 10
        },
        subPageParm:{
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    created(){
       this.user = JSON.parse(sessionStorage.getItem('userdata'))
       let d = new Date()
       let s = new Date(d.getTime() - (2 * 24 * 60 * 60 * 1000))
       let e = new Date(d.getTime() - 24*60*60*1000)
       this.formInline.startTime = timestampToTime(s).substring(0,10)
       this.formInline.endTime = timestampToTime(e).substring(0,10)


       this.dayStr = [ this.formInline.startTime, this.formInline.endTime]


       //

       this.getJzData()





    },
    mounted(){
      this.$nextTick(() => {

        this.tableHeight = window.innerHeight - 300
      })
    },
    components: {
    	Pagination
    },
    methods:{
      getJzData:function(){
      	return new Promise((resolve,reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if(res.status == 1){
      				let arr = []
      				this.deptList = res.data.menuDepList
              this.formInline.depId = res.data.menuDepList[0].id
              this.departmentId = res.data.menuDepList[0].id
              this.diff = res.data.menuDepList[0].diff || 0
              this.getAreaData()
               this.getData()

      			}
      			else{
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },

      //获取区域列表
      getAreaData(){
        this.loading = true
        findAreaList({depId:this.formInline.depId}).then(res => {
          this.loading = false
          if(res.status == 1){
            this.areaList = res.data.data
          }
        })
      },

      chageDept(e){
        this.getData()
        this.getAreaData()
        this.diff =  this.deptList.filter(item => item.id == e)[0].diff || 0
      },
      getDate(val){
        this.formInline.startTime = val[0]
        this.formInline.endTime = val[1]
      },

      showChild(row){

        this.subFrom = true
        this.terId = row.terminalId
        this.formInline.meterId  = row.meterId
        this.subPageParm.currentPage = 1


        this.breadList.push(row)

        this.getChildData()
      },

      getChildDataByIdx(item,idx){
        if(idx != this.breadList.length-1){
          this.formInline.meterId = item.meterId
          this.breadList.splice(idx+1,10)
          this.subPageParm.currentPage = 1

          this.getChildData()
        }
      },
      childClose(){
        this.breadList = []
      },
      search(){

          this.pageparm.currentPage = 1
          this.formInline.currentPage = 1
          this.showPage  =  false;
          this.getData()
          this.$nextTick(() => {
          	this.showPage = true
          })
      },
      callFather(parm){
        this.pageparm.currentPage = parm.currentPage
        this.pageparm.pageSize = parm.pageSize
        this.getData()
      },
      callFatherSub(param){
        this.subPageParm.currentPage = param.currentPage
        this.subPageParm.pageSize = param.pageSize
        this.getChildData()
      },
      getData(){
        this.loading = true
        this.formInline.meterId = ''
        let param  = {
          ...this.formInline,
          ...this.pageparm
        }
        getMainMeterInfoDataByCode(param).then(res => {
          this.loading = false
          if(res.status == 1) {
            this.dataList = res.data.data
            this.pageparm.total = res.data.totalCount
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      //查看子表
      getChildData(){
        this.loadMeter = true

        let param  = {
          ...this.formInline,
          ...this.subPageParm
        }




        console.log(this.formInline)

        getMainMeterInfoDataByCode(param).then(res => {
          this.loadMeter = false
          if(res.status == 1) {
            this.subList = res.data.data
            this.subPageParm.total = res.data.totalCount
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      tableRowClassName({row,rowIndex}){

        if(this.diff){
          let rDiff =  parseFloat(row.difference)

          if ( rDiff >= 0){
            if(rDiff > this.diff){
              return 'rowRed';
            }
          }else {


            if(rDiff < (0-this.diff)){
               return 'rowRed';
            }
          }
        }else{
          return ""
        }


      }
    }
  }
</script>

<style>
  .stepBox{
    margin-bottom: 20px;
    display: flex;
  }
  .rowRed{
    color: red;
  }
  .stepItem{
    display: flex;
    cursor: pointer;
    margin-right: 10px;
    line-height: 14px;
  }
  .stepItem:hover{
    color: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/views/analysis/xs.vue